var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useMemo, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Checkbox, Col, ConfirmationModal, Datepicker, MessageBanner, Modal, ModalFooter, Row, } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { deleteVolume, previewVolumeWindow, updateVolumeWindow, } from "../../api/periodicalIssueService";
import { invalidateVolumeViews } from "../../hooks/usePeriodicalVolumes";
import { extractServerErrorMessage, readErrorCode, } from "../../utils/errorHandler";
import { invalidateDepositRecordViews } from "../../utils/depositRecordQueries";
import { EMPTY_CHOICES, EMPTY_PERIODS, areChoicesValid, buildVolumeWindowRequest, findShrunkNeighbour, resolveChoice, } from "../../utils/freedPeriodChoice";
import { describeVolume, formatVolumeAnchor, isIsoDate, } from "../../utils/volumeWindow";
import { ErrorType } from "../../types/ErrorType";
import { FreedPeriodChoice } from "./FreedPeriodChoice";
import { VolumeWindowPreview } from "./VolumeWindowPreview";
import css from "./VolumeWindowDialog.module.css";
var MESSAGE_PREFIX = "ui-br-legaldeposits.periodicals.volume.window";
var VolumeWindowDialogBody = function (_a) {
    var _b, _c, _d, _f, _g;
    var volume = _a.volume, periodicalLibraryId = _a.periodicalLibraryId, onClose = _a.onClose, onDeleted = _a.onDeleted;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var initialStart = useState(volume.startDate)[0];
    var initialEnd = useState(volume.endDate)[0];
    var _h = useState(initialStart), startDate = _h[0], setStartDate = _h[1];
    var _j = useState(initialEnd), endDate = _j[0], setEndDate = _j[1];
    var _k = useState(EMPTY_CHOICES), choices = _k[0], setChoices = _k[1];
    var _l = useState(true), fillFromSchedule = _l[0], setFillFromSchedule = _l[1];
    var _m = useState(volume.anchorReference), adoptAnchor = _m[0], setAdoptAnchor = _m[1];
    var _o = useState(null), previewError = _o[0], setPreviewError = _o[1];
    var _p = useState(null), saveError = _p[0], setSaveError = _p[1];
    var _q = useState(false), planStale = _q[0], setPlanStale = _q[1];
    var _r = useState(false), deleteConfirmOpen = _r[0], setDeleteConfirmOpen = _r[1];
    var datesValid = isIsoDate(startDate) && isIsoDate(endDate) && startDate <= endDate;
    var changed = startDate !== initialStart || endDate !== initialEnd;
    var windowChanged = changed && datesValid;
    var errorFallback = formatMessage({ id: "".concat(MESSAGE_PREFIX, ".error") });
    var showQueryError = useCallback(function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setPreviewError;
                    return [4 /*yield*/, extractServerErrorMessage(error, formatMessage, errorFallback)];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    }); }, [formatMessage, errorFallback]);
    var probeRequest = useMemo(function () {
        return buildVolumeWindowRequest({
            startDate: startDate,
            endDate: endDate,
            periodicalLibraryId: periodicalLibraryId,
            fillFromSchedule: fillFromSchedule,
            adoptStartAsAnchor: adoptAnchor,
            freedPeriods: EMPTY_PERIODS,
            choices: EMPTY_CHOICES,
        });
    }, [startDate, endDate, periodicalLibraryId, fillFromSchedule, adoptAnchor]);
    // the probe carries the request a preview would send when nothing is freed, so then it is the preview
    var probeQuery = useQuery(["volumeWindowProbe", volume.id, probeRequest], function () { return previewVolumeWindow(kyInstance, volume.id, probeRequest); }, {
        enabled: windowChanged,
        keepPreviousData: true,
        retry: false,
        staleTime: 0,
        cacheTime: 0,
        onSuccess: function (data) {
            if (data.freedPeriods.length === 0)
                setPreviewError(null);
        },
        onError: showQueryError,
    });
    var probeData = ((_b = probeQuery.data) === null || _b === void 0 ? void 0 : _b.startDate) === startDate &&
        ((_c = probeQuery.data) === null || _c === void 0 ? void 0 : _c.endDate) === endDate
        ? probeQuery.data
        : undefined;
    var freedPeriods = (_d = probeData === null || probeData === void 0 ? void 0 : probeData.freedPeriods) !== null && _d !== void 0 ? _d : EMPTY_PERIODS;
    var hasFreedPeriods = freedPeriods.length > 0;
    var fillAvailable = (probeData === null || probeData === void 0 ? void 0 : probeData.fillAvailable) === true;
    var anchorChange = (_f = probeData === null || probeData === void 0 ? void 0 : probeData.anchorChange) !== null && _f !== void 0 ? _f : null;
    var refetchProbe = probeQuery.refetch;
    var choicesValid = useMemo(function () { return areChoicesValid(freedPeriods, choices); }, [freedPeriods, choices]);
    var request = useMemo(function () {
        return buildVolumeWindowRequest({
            startDate: startDate,
            endDate: endDate,
            periodicalLibraryId: periodicalLibraryId,
            fillFromSchedule: fillFromSchedule,
            adoptStartAsAnchor: adoptAnchor,
            freedPeriods: freedPeriods,
            choices: choices,
        });
    }, [
        startDate,
        endDate,
        periodicalLibraryId,
        fillFromSchedule,
        adoptAnchor,
        freedPeriods,
        choices,
    ]);
    var resolutionsNeeded = windowChanged && hasFreedPeriods && choicesValid;
    var previewQuery = useQuery(["volumeWindowPreview", volume.id, request], function () { return previewVolumeWindow(kyInstance, volume.id, request); }, {
        enabled: resolutionsNeeded,
        retry: false,
        staleTime: 0,
        cacheTime: 0,
        onSuccess: function () { return setPreviewError(null); },
        onError: showQueryError,
    });
    var refetchPreview = previewQuery.refetch;
    var preview = null;
    if (windowChanged && !hasFreedPeriods) {
        preview = probeQuery.isPreviousData ? null : (probeData !== null && probeData !== void 0 ? probeData : null);
    }
    else if (resolutionsNeeded && !previewQuery.isError) {
        preview = (_g = previewQuery.data) !== null && _g !== void 0 ? _g : null;
    }
    var saveMutation = useMutation(function (saveRequest) {
        return updateVolumeWindow(kyInstance, volume.id, saveRequest);
    }, {
        onSuccess: function () {
            invalidateVolumeViews(queryClient);
            invalidateDepositRecordViews(queryClient);
            onClose();
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, readErrorCode(error)];
                    case 1:
                        if ((_b.sent()) === ErrorType.VOLUME_WINDOW_PLAN_STALE) {
                            setSaveError(null);
                            setPlanStale(true);
                            refetchProbe();
                            if (hasFreedPeriods)
                                refetchPreview();
                            return [2 /*return*/];
                        }
                        _a = setSaveError;
                        return [4 /*yield*/, extractServerErrorMessage(error, formatMessage, errorFallback)];
                    case 2:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var deleteMutation = useMutation(function () { return deleteVolume(kyInstance, volume.id); }, {
        onSuccess: function () {
            setDeleteConfirmOpen(false);
            invalidateVolumeViews(queryClient);
            invalidateDepositRecordViews(queryClient);
            onDeleted === null || onDeleted === void 0 ? void 0 : onDeleted(volume.id);
            onClose();
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setDeleteConfirmOpen(false);
                        _a = setSaveError;
                        return [4 /*yield*/, extractServerErrorMessage(error, formatMessage, errorFallback)];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var handleSave = useCallback(function () {
        if (!preview)
            return;
        setSaveError(null);
        setPlanStale(false);
        saveMutation.mutate(__assign(__assign({}, request), { planToken: preview.planToken }));
    }, [saveMutation, request, preview]);
    var clearFeedback = useCallback(function () {
        setPreviewError(null);
        setSaveError(null);
        setPlanStale(false);
    }, []);
    var handleStartChange = useCallback(function (_e, _displayed, isoDate) {
        clearFeedback();
        setStartDate(isoDate);
    }, [clearFeedback]);
    var handleEndChange = useCallback(function (_e, _displayed, isoDate) {
        clearFeedback();
        setEndDate(isoDate);
    }, [clearFeedback]);
    var handleChoiceChange = useCallback(function (side, change) {
        clearFeedback();
        setChoices(function (current) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[side] = __assign(__assign({}, current[side]), change), _a)));
        });
    }, [clearFeedback]);
    var handleFillChange = useCallback(function (e) {
        clearFeedback();
        setFillFromSchedule(e.target.checked);
    }, [clearFeedback]);
    var handleAdoptAnchorChange = useCallback(function (e) {
        clearFeedback();
        setAdoptAnchor(e.target.checked);
    }, [clearFeedback]);
    var periodViews = useMemo(function () {
        return freedPeriods.map(function (period) {
            var createdVolume = preview === null || preview === void 0 ? void 0 : preview.createdVolumes.find(function (candidate) { return candidate.side === period.side; });
            return {
                period: period,
                createdVolume: createdVolume,
                choice: resolveChoice(period, choices[period.side]),
                shrunkNeighbour: preview
                    ? findShrunkNeighbour(preview, period, createdVolume)
                    : null,
            };
        });
    }, [freedPeriods, choices, preview]);
    var loading = windowChanged && (probeQuery.isFetching || previewQuery.isFetching);
    var busy = saveMutation.isLoading || deleteMutation.isLoading;
    var saveDisabled = busy || loading || !(preview === null || preview === void 0 ? void 0 : preview.applicable);
    var footer = (React.createElement(ModalFooter, null,
        React.createElement(Button, { buttonStyle: "primary", onClick: handleSave, disabled: saveDisabled }, formatMessage({ id: "ui-br-legaldeposits.button.save" })),
        React.createElement(Button, { onClick: onClose, disabled: busy }, formatMessage({ id: "ui-br-legaldeposits.button.cancel" })),
        volume.deletable && (React.createElement(Button, { buttonStyle: "danger", onClick: function () { return setDeleteConfirmOpen(true); }, disabled: busy }, formatMessage({
            id: "ui-br-legaldeposits.periodicals.volume.delete",
        })))));
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { open: true, onClose: onClose, dismissible: true, label: formatMessage({ id: "".concat(MESSAGE_PREFIX, ".title") }, { volume: volume.label }), footer: footer },
            React.createElement("p", null, formatMessage({ id: "".concat(MESSAGE_PREFIX, ".intro") }, { volume: describeVolume(volume), count: volume.issueCount })),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 6 },
                    React.createElement(Datepicker, { value: startDate, onChange: handleStartChange, backendDateStandard: "YYYY-MM-DD", dateFormat: "DD/MM/YYYY", placeholder: "DD/MM/RRRR", label: formatMessage({ id: "".concat(MESSAGE_PREFIX, ".start") }), required: true })),
                React.createElement(Col, { xs: 6 },
                    React.createElement(Datepicker, { value: endDate, onChange: handleEndChange, backendDateStandard: "YYYY-MM-DD", dateFormat: "DD/MM/YYYY", placeholder: "DD/MM/RRRR", label: formatMessage({ id: "".concat(MESSAGE_PREFIX, ".end") }), error: isIsoDate(startDate) && isIsoDate(endDate) && !datesValid
                            ? formatMessage({
                                id: "ui-br-legaldeposits.field.error.VOLUME_WINDOW_INVALID",
                            })
                            : undefined, required: true }))),
            React.createElement("p", { className: css.hint }, formatMessage({ id: "".concat(MESSAGE_PREFIX, ".hint") })),
            !volume.deletable && (React.createElement("p", { className: css.hint }, formatMessage({ id: "ui-br-legaldeposits.periodicals.volume.deleteBlocked" }, { count: volume.issueCount }))),
            periodViews.map(function (_a) {
                var period = _a.period, createdVolume = _a.createdVolume, choice = _a.choice, shrunkNeighbour = _a.shrunkNeighbour;
                return (React.createElement(FreedPeriodChoice, { key: period.side, period: period, choice: choice, createdVolume: createdVolume, shrunkNeighbour: shrunkNeighbour, onChange: handleChoiceChange }));
            }),
            windowChanged && fillAvailable && (React.createElement("div", { className: css.fill },
                React.createElement(Checkbox, { id: "volume-window-fill", label: formatMessage({ id: "".concat(MESSAGE_PREFIX, ".fill.label") }), checked: fillFromSchedule, onChange: handleFillChange }),
                React.createElement("p", { className: css.hint }, formatMessage({ id: "".concat(MESSAGE_PREFIX, ".fill.hint") })))),
            windowChanged && anchorChange && (React.createElement("div", { className: css.fill }, anchorChange.toDay && anchorChange.toMonth ? (React.createElement(React.Fragment, null,
                React.createElement(Checkbox, { id: "volume-window-adopt-anchor", label: formatMessage({ id: "".concat(MESSAGE_PREFIX, ".adoptAnchor.label") }, {
                        anchor: formatVolumeAnchor(formatMessage, anchorChange.toDay, anchorChange.toMonth),
                    }), checked: adoptAnchor, onChange: handleAdoptAnchorChange }),
                React.createElement("p", { className: css.hint }, formatMessage({ id: "".concat(MESSAGE_PREFIX, ".adoptAnchor.hint") }, {
                    current: formatVolumeAnchor(formatMessage, anchorChange.fromDay, anchorChange.fromMonth),
                })))) : (React.createElement("p", { className: css.hint }, formatMessage({ id: "".concat(MESSAGE_PREFIX, ".adoptAnchor.leapDay") }, {
                current: formatVolumeAnchor(formatMessage, anchorChange.fromDay, anchorChange.fromMonth),
            }))))),
            loading && (React.createElement("p", null, formatMessage({ id: "ui-br-legaldeposits.loading" }))),
            planStale && (React.createElement(MessageBanner, { type: "warning" }, formatMessage({ id: "".concat(MESSAGE_PREFIX, ".stale") }))),
            previewError && (React.createElement(MessageBanner, { type: "error" }, previewError)),
            preview && !loading && React.createElement(VolumeWindowPreview, { preview: preview }),
            saveError && React.createElement(MessageBanner, { type: "error" }, saveError)),
        React.createElement(ConfirmationModal, { open: deleteConfirmOpen, heading: formatMessage({ id: "ui-br-legaldeposits.periodicals.volume.delete.heading" }, { volume: volume.label }), message: formatMessage({ id: "ui-br-legaldeposits.periodicals.volume.delete.message" }, { volume: describeVolume(volume) }), confirmLabel: formatMessage({
                id: "ui-br-legaldeposits.periodicals.volume.delete",
            }), cancelLabel: formatMessage({ id: "ui-br-legaldeposits.button.cancel" }), onConfirm: function () { return deleteMutation.mutate(); }, onCancel: function () { return setDeleteConfirmOpen(false); }, isConfirmButtonDisabled: deleteMutation.isLoading })));
};
// the body mounts only while the dialog is open, so every close or volume switch starts from a clean form
export var VolumeWindowDialog = function (_a) {
    var open = _a.open, volume = _a.volume, rest = __rest(_a, ["open", "volume"]);
    return open ? (React.createElement(VolumeWindowDialogBody, __assign({ key: volume.id, volume: volume }, rest))) : null;
};
